export default function updateAction(state, payload) {
  return {
    ...state,
    troskovnikItem: {
      ...state.troskovnikItem,
      ...payload,
    },
  };
}
